import { render, staticRenderFns } from "./AcidifyingHome.vue?vue&type=template&id=0ac659a8&scoped=true&"
import script from "./AcidifyingHome.vue?vue&type=script&lang=js&"
export * from "./AcidifyingHome.vue?vue&type=script&lang=js&"
import style0 from "./AcidifyingHome.vue?vue&type=style&index=0&id=0ac659a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac659a8",
  null
  
)

export default component.exports